import React from 'react';
import Modal from './Modal';

export default function ContactModal({ onClose }) {
  return (
    <Modal title="📞 Contact Us" onClose={onClose}>
      <div style={{ textAlign: 'center' }}>
        <div style={{ fontSize: '3rem', marginBottom: '16px' }}>🎮</div>
        <p style={{ color: '#aaa', marginBottom: '8px' }}>
          Got a bug or feedback?<br />We'd love to hear from you!
        </p>

        <div className="contact-card">
          <div style={{ color: '#888', fontSize: '0.85rem', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '1px' }}>
            Support Number
          </div>
          <div className="contact-number">📱 +91 98765 43210</div>
          <div style={{ color: '#888', fontSize: '0.85rem' }}>Mon–Sat, 10am–6pm IST</div>
        </div>

        <div className="contact-card">
          <div style={{ color: '#888', fontSize: '0.85rem', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '1px' }}>
            Email
          </div>
          <div style={{ color: '#4D96FF', fontFamily: 'Fredoka One', fontSize: '1.1rem', margin: '6px 0' }}>
            support@resourcerush.game
          </div>
        </div>
      </div>
    </Modal>
  );
}